/* Whole-page states before the shell exists: loading and a failed session check. */
.status {
  max-width: 440px;
  margin: var(--dimension-space-12) auto;
  padding: 0 var(--gutter);
  color: var(--color-text-secondary);
}
.error {
  color: var(--color-status-danger);
}
